import { HttpErrorResponse, HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, throwError } from "rxjs";
import { catchError } from 'rxjs/operators';
import { MessageService } from "../_services/message.service";
import { TokenService } from '../_services/token.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

    constructor(
        private tokenService: TokenService,
        private messageService: MessageService,
        private router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent
        | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {

        if (!this.isAuthenticationRoute(req.url)) {
            if (this.tokenService.hasToken()) {
                let token = this.tokenService.getToken();

                req = req.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`
                    }
                });

                let tokenExpirationDate = this.tokenService.getTokenExpirationDate(token);
                let date = new Date();

                if (!req.url.includes("Token")) {
                    if (date >= tokenExpirationDate) {
                        this.tokenService.refreshToken().subscribe(
                            res => {},
                            err => {
                                if (err.status == 401) {
                                    this.tokenService.logout();
                                    this.router.navigate([window.location.pathname]);
                                }
                            }
                        );
                    }
                }
            }

        }

        if (req.url.includes("Token")) {
            return next.handle(req);
        }

        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status == 401) {
                    this.tokenService.logout();
                    this.messageService.warning("A sua sessão expirou. Realize novamente o login para acessar o sistema.", "Sessão expirada");
                    this.router.navigate(['login']);
                }

                return throwError(error);
            })
        );
    }

    private isAuthenticationRoute(url: string): boolean {
        return url.endsWith('/Token') || url.includes('/Token/Autentica');
    }
}
